//# sourceMappingURL=kind.mjs.map
/// <reference types="./kind.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import { CustomType as $CustomType } from "../../gleam.mjs";

export class Table extends $CustomType {}
export const Kind$Table = () => new Table();
export const Kind$isTable = (value) => value instanceof Table;

export class Question extends $CustomType {}
export const Kind$Question = () => new Question();
export const Kind$isQuestion = (value) => value instanceof Question;

export class Section extends $CustomType {}
export const Kind$Section = () => new Section();
export const Kind$isSection = (value) => value instanceof Section;

export class Subsection extends $CustomType {}
export const Kind$Subsection = () => new Subsection();
export const Kind$isSubsection = (value) => value instanceof Subsection;

export class Outline extends $CustomType {}
export const Kind$Outline = () => new Outline();
export const Kind$isOutline = (value) => value instanceof Outline;

export class Other extends $CustomType {}
export const Kind$Other = () => new Other();
export const Kind$isOther = (value) => value instanceof Other;

export function decoder() {
  return $decode.then$(
    $decode.string,
    (content) => {
      if (content === "question") {
        return $decode.success(new Question());
      } else if (content === "question-answer") {
        return $decode.success(new Question());
      } else if (content === "question_answer") {
        return $decode.success(new Question());
      } else if (content === "section") {
        return $decode.success(new Section());
      } else if (content === "subsection") {
        return $decode.success(new Subsection());
      } else if (content === "other") {
        return $decode.success(new Other());
      } else if (content === "table") {
        return $decode.success(new Table());
      } else if (content === "table_with_questions") {
        return $decode.success(new Table());
      } else if (content === "outline") {
        return $decode.success(new Outline());
      } else {
        return $decode.success(new Other());
      }
    },
  );
}

export function to_string(kind) {
  if (kind instanceof Table) {
    return "table";
  } else if (kind instanceof Question) {
    return "question";
  } else if (kind instanceof Section) {
    return "section";
  } else if (kind instanceof Subsection) {
    return "subsection";
  } else if (kind instanceof Outline) {
    return "outline";
  } else {
    return "other";
  }
}

export function encode(kind) {
  let _pipe = to_string(kind);
  return $json.string(_pipe);
}

export function question_decoder() {
  return $decode.then$(
    decoder(),
    (content) => {
      if (content instanceof Table) {
        return $decode.failure(new Question(), "Question");
      } else if (content instanceof Question) {
        return $decode.success(new Question());
      } else if (content instanceof Section) {
        return $decode.failure(new Question(), "Question");
      } else if (content instanceof Subsection) {
        return $decode.failure(new Question(), "Question");
      } else if (content instanceof Outline) {
        return $decode.failure(new Question(), "Question");
      } else {
        return $decode.failure(new Question(), "Question");
      }
    },
  );
}

export function block_decoder() {
  return $decode.then$(
    decoder(),
    (content) => {
      if (content instanceof Table) {
        return $decode.success(content);
      } else if (content instanceof Question) {
        return $decode.failure(new Other(), "Block");
      } else if (content instanceof Section) {
        return $decode.success(content);
      } else if (content instanceof Subsection) {
        return $decode.success(content);
      } else if (content instanceof Outline) {
        return $decode.success(content);
      } else {
        return $decode.success(content);
      }
    },
  );
}

export function table_decoder() {
  return $decode.then$(
    decoder(),
    (content) => {
      if (content instanceof Table) {
        return $decode.success(new Table());
      } else if (content instanceof Question) {
        return $decode.failure(new Other(), "Table");
      } else if (content instanceof Section) {
        return $decode.failure(new Other(), "Table");
      } else if (content instanceof Subsection) {
        return $decode.failure(new Other(), "Table");
      } else if (content instanceof Outline) {
        return $decode.failure(new Other(), "Table");
      } else {
        return $decode.failure(new Other(), "Table");
      }
    },
  );
}

export function outline_decoder() {
  return $decode.then$(
    decoder(),
    (content) => {
      if (content instanceof Table) {
        return $decode.failure(new Other(), "Outline");
      } else if (content instanceof Question) {
        return $decode.failure(new Other(), "Outline");
      } else if (content instanceof Section) {
        return $decode.failure(new Other(), "Outline");
      } else if (content instanceof Subsection) {
        return $decode.failure(new Other(), "Outline");
      } else if (content instanceof Outline) {
        return $decode.success(new Outline());
      } else {
        return $decode.failure(new Other(), "Outline");
      }
    },
  );
}
